import { Reveal } from "./motion";
import { IMAGES } from "./data";

const STEPS = [
  {
    num: "01",
    title: "Offer or find a ride",
    body: "Drivers post their inter-city route, seats and price. Riders search destinations and find trips leaving when they need them.",
    img: IMAGES.offerRide,
    alt: "Driver and passenger in a car",
    color: "#2340b5",
  },
  {
    num: "02",
    title: "Book your seat",
    body: "Review the driver's profile, ratings and verified badges. Reserve instantly and pay securely — all inside the app.",
    img: IMAGES.bookRide,
    alt: "Person booking a ride on a smartphone",
    color: "#fdb913",
  },
  {
    num: "03",
    title: "Travel together",
    body: "Meet at the pickup point, hit the road and split the cost. Rate each other afterwards to keep the community trusted.",
    img: IMAGES.routeAerial,
    alt: "Aerial view of a car on a scenic road",
    color: "#e4002b",
  },
];

export const HowItWorks = () => {
  return (
    <section id="how" className="relative bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <Reveal className="mb-20 max-w-3xl">
          <p className="mb-6 inline-flex items-center gap-3 font-display text-xs font-semibold uppercase tracking-[0.22em] text-[#2340b5]">
            <span className="h-px w-10 bg-[#2340b5]" /> How it works
          </p>
          <h2 className="font-display text-4xl font-extrabold leading-none tracking-tighter text-[#12142b] sm:text-5xl lg:text-6xl">
            Three steps to a<br /> smarter journey.
          </h2>
        </Reveal>

        <div className="flex flex-col">
          {STEPS.map((step, i) => (
            <div
              key={step.num}
              className={`grid grid-cols-1 items-center gap-8 border-t border-[#12142b]/10 py-14 md:grid-cols-12 lg:gap-12 ${
                i === STEPS.length - 1 ? "border-b" : ""
              }`}
            >
              <Reveal className="md:col-span-1" delay={0.05}>
                <span
                  className="font-display text-6xl font-black leading-none lg:text-7xl"
                  style={{ color: step.color, opacity: 0.18 }}
                >
                  {step.num}
                </span>
              </Reveal>

              <Reveal className={`md:col-span-5 ${i % 2 === 1 ? "md:order-last" : ""}`} delay={0.1}>
                <h3 className="mb-4 font-display text-2xl font-bold tracking-tight text-[#12142b] lg:text-3xl">
                  {step.title}
                </h3>
                <p className="max-w-md text-base leading-relaxed text-[#565b73]">{step.body}</p>
              </Reveal>

              <Reveal className="md:col-span-6" delay={0.15}>
                <div className="group relative overflow-hidden rounded-3xl shadow-lg shadow-[#12142b]/5">
                  <img
                    src={step.img}
                    alt={step.alt}
                    className="aspect-[16/10] w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <span
                    className="absolute right-4 top-4 rounded-full bg-white/90 px-3 py-1 font-display text-[10px] font-bold uppercase tracking-[0.2em] backdrop-blur"
                    style={{ color: step.color }}
                  >
                    {step.num} / 03
                  </span>
                </div>
              </Reveal>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
